import { Component } from '@angular/core';
// import { StatCardComponent } from './stat-card/stat-card.component';
import { ChartModule } from 'primeng/chart';
// import { ChartBuilderComponent } from '../../components/chart-builder/chart-builder.component';
import { ChartVariant, DoughnutChartProps, DynamicChart, LineChartProps } from '@/components/chart-builder/chart-builder.types';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'sm-dashboard',
  imports: [ChartModule, CardModule], //StatCardComponent, ChartBuilderComponent
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  acChart: DynamicChart<DoughnutChartProps> = {
    variant: ChartVariant.DOUGHNUT,
    width: '30rem',
    data: {
      labels: ['Autorité contractante 1', 'Autorité contractante 2', 'Autorité contractante 3', 'Autorité contractante 4'],
      values: [440, 625, 802, 100],
      backgroundColors: ['#FB9C0C', '#195F2E', '#00A95C', '#DA291C'],
      hoverBackgroundColors: [],
      labelPosition: 'right',
    },
  };

  chart: DynamicChart<LineChartProps> = {
    title: 'Monthly Sales',
    variant: ChartVariant.LINE,
    width: '43rem',
    data: {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [
        {
          label: '2021',
          data: [100, 200, 300, 250, 400, 500, 600, 700, 800, 900, 1000, 1100],
          borderColor: '#195F2E',
          tension: 0.4,
        },
        {
          label: '2020',
          data: [40, 100, 120, 90, 40, 100, 120, 90, 40, 100, 120, 90],
          borderColor: '#5FDA88',
        },
        {
          label: '2019',
          data: [40, 70, 500, 40, 70, 500, 40, 70, 500, 40, 70, 500],
          borderColor: '#00A95C',
        },
      ],
    },
  };
}
